module.exports = __webpack_public_path__ + "img/content-m.28750e6e.png";